// import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import Model from "~/models/_Model";
import Session from "./Session";
import ScanLog from "./ScanLog";
import { useDayjs } from '#dayjs';
const dayjs = useDayjs();
dayjs.extend(relativeTime);
dayjs.extend(utc);

export default class Station extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/scanning";
  }

  primaryKey() {
    return "hardware_uuid";
  }
  
  // Set the resource route of the model
  resource() {
    return "stations";
  }

  relations() {
    return {
      sessions: Session,
      scan_logs: ScanLog,
    };
  }

  get display_status_icon() {
    switch (this.status) {
      case "Error":
        return "error";
      default:
        return "check";
    }
  }

  get display_status_color() {
    switch (this.status) {
      case "Running":
        return "positive";
      case "Error":
        return "negative";
      default:
        return "info";
    }
  }

  get display_active_icon() {
    return this.active ? "check" : "error";
  }

  get display_active_color() {
    return this.active ? "positive" : "negative";
  }

  get display_last_checkin_at() {
    if (!this.last_checkin_at) {
      return "";
    }
    //"MM/DD/YYYY @ h:mm:ss A"
    //dayjs(this.last_checkin_at).local().format("ddd, DD MMM YYYY hh:mm:ss A"),
    const last_checkin = dayjs(this.last_checkin_at).local();
    return `${last_checkin.format(
      "ddd, DD MMM YYYY hh:mm:ss A"
    )} (${last_checkin.fromNow()})`;
  }
}
